import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import packageImg from "../../assets/servicepackage.jpg";
import "./ezympspackage.css";

const features = [
  {
    number: 1,
    title: "Priority Replacement of Parts",
    description:
      "Ensures critical components are replaced promptly to minimize downtime.",
  },
  {
    number: 2,
    title: "No Advance Payment for Support Visits",
    description:
      "Our team will provide support without upfront charges for visit requests.",
  },
  {
    number: 3,
    title: "Annual Preventive Maintenance",
    description:
      "We perform routine annual maintenance to keep your systems running smoothly.",
  },
  {
    number: 4,
    title: "24x7 Support Coverage",
    description:
      "Round-the-clock technical support to address urgent issues anytime.",
  },
];

const EzyMpspackage = () => {
  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <section style={{ padding: "60px 0", backgroundColor: "#f8f9fa" }}>
          <Container>
            <Row className="align-items-center">
              <Col md={6}>
                <h2 className="mb-4 title-font text-start" data-aos="zoom-in">
                  EZYMPS Service Packages
                </h2>
                <p className="mb-5" data-aos="zoom-in">
                  EZYMPS is a smart, cloud-based Managed Print Services (MPS)
                  and ERP platform that brings transparency, efficiency, and
                  real-time control to your printing infrastructure.
                </p>

                {features.map((feature) => (
                  <div
                    key={feature.number}
                    className="mb-3 d-flex align-items-start"
                    data-aos="zoom-in"
                  >
                    <div className="feature-number me-3 theme-font-color">
                      {feature.number}
                    </div>
                    <div>
                      <h5 className="fw-bolder">{feature.title}</h5>
                      <p className="fs-14">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </Col>

              <Col md={6}>
                <img
                  src={packageImg}
                  alt="EZYMPS Package"
                  className="w-100 rounded"
                  data-aos="zoom-in"
                />
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
};

export default EzyMpspackage;
